import {
	Button,
	Heading,
	Modal,
	ModalBody,
	ModalCloseButton,
	ModalContent,
	ModalFooter,
	ModalHeader,
	ModalOverlay,
} from '@chakra-ui/react';
import EditAvailabilityModalBody from './components/edit-availability-modal-body.view';
import useEditAvailabilityModal from './edit-availability.controller';

interface AddLinkModalProps {
	id: string;
	isOpen: boolean;
	close: () => void;
}

export default function EditAvailabilityModal(props: AddLinkModalProps) {
	const { t, query } = useEditAvailabilityModal(props);

	return (
		<Modal isOpen={props.isOpen} onClose={props.close} size="2xl" isCentered>
			<ModalOverlay />
			<ModalContent h={{ base: 'full', md: '80dvh' }} overflow="hidden">
				<ModalHeader>
					<Heading size="lg">{t('Edit availability')}</Heading>
				</ModalHeader>
				<ModalCloseButton />
				<ModalBody overflow="auto">{query.data ? <EditAvailabilityModalBody resource={query.data} /> : null}</ModalBody>
				<ModalFooter>
					<Button variant="ghost" mr={3} onClick={props.close}>
						{t('Close')}
					</Button>
				</ModalFooter>
			</ModalContent>
		</Modal>
	);
}
